"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SectionHeader = function (_a) {
    var title = _a.title;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.header_section },
        react_1.default.createElement("p", { className: styles_module_scss_1.default.header }, title)));
};
exports.default = SectionHeader;
